(function () {
    "use strict";

    var serviceId = "poiService";
    angular
        .module("app.common")
        .factory(serviceId, [
            "$q",
            "poiAPICache",
            "$ocLazyLoad",
            "auth_factory",
            bolgeselDataService
        ]);

    function bolgeselDataService(
        $q,
        poiAPICache,
        $ocLazyLoad,
        auth_factory
    ) {
        var service = {
            getPOI: getPOI
        };

        return service;

        function getPOI(payload) {
            var deferred = $q.defer();

            var requester;

            var $cancelRequest = function () {
                if (requester)
                    requester.$cancelRequest();
            };
            requester = poiAPICache.get(Object.assign(payload, {captchaTokenCustom: window.ecSec()}));
            requester.$promise.then(
                function (response) {
                    return deferred.resolve(response);
                }, 
                function (err) {
                    return deferred.reject(err);
                }
            );


            return { $promise: deferred.promise, $cancelRequest: $cancelRequest };
        }

    }
})();